import { render } from "./AbonnementExpirerView.vue?vue&type=template&id=c725d966"
import script from "./AbonnementExpirerView.vue?vue&type=script&lang=js"
export * from "./AbonnementExpirerView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__